const BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Access Token 갱신
export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) return null;

  const res = await fetch(`${BASE_URL}/auth/refresh`, {
    method : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body   : JSON.stringify({ refreshToken })
  });
  const data = await res.json();

  if (data.success) {
    localStorage.setItem('token', data.accessToken);
    return data.accessToken;
  }
  return null;
};

// 비밀번호 변경
export const changePassword = async (currentPassword, newPassword, confirmPassword) => {
  const res = await fetch(`${BASE_URL}/auth/change-password`, {
    method : 'POST',
    headers: {
      'Content-Type' : 'application/json',
      Authorization  : `Bearer ${localStorage.getItem('token')}`
    },
    body: JSON.stringify({ currentPassword, newPassword, confirmPassword })
  });
  return await res.json();
};

// 로그아웃
export const logoutApi = async () => {
  const res = await fetch(`${BASE_URL}/auth/logout`, {
    method : 'POST',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });
  return await res.json();
};

// 비밀번호 초기화
export const resetPassword = async (emp_no, phone_last4, newPassword, confirmPassword, branch_code, division_code) => {
  const res = await fetch(`${BASE_URL}/auth/reset-password`, {
    method : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body   : JSON.stringify({ emp_no, phone_last4, newPassword, confirmPassword, branch_code, division_code })
  });
  return await res.json();
};